import { takeCustomLatest } from 'state/common/common.effects'
import {
  createNewSaleAssignmentEffects,
  fetchActiveSaleAllocationsEffect,
  refetchListWithIdAndPopulateStore,
  createNewSaleAllocationEffects,
  initSaleAssignmentEffect,
  getSaleAllocationEffects,
  updateSaleAllocationEffects
} from './list.effect'
import { listActions } from './list.actions'

function* refetchListSaga() {
  yield takeCustomLatest(
    listActions.REFETCH_LIST_AND_POPULATE_STORE,
    refetchListWithIdAndPopulateStore
  )
}

function* fetchActiveSalesAllocationSaga() {
  yield takeCustomLatest(listActions.FETCH_ACTIVE_SALE_ALLOCATION, fetchActiveSaleAllocationsEffect)
}

function* createNewSaleAssignmentSaga() {
  yield takeCustomLatest(listActions.CREATE_ACTIVE_SALE_ASSIGNMENT, createNewSaleAssignmentEffects)
}

function* createNewSaleAllocationSaga() {
  yield takeCustomLatest(listActions.CREATE_ACTIVE_SALE_ALLOCATION, createNewSaleAllocationEffects)
}

function* initSaleAssignmentSaga() {
  yield takeCustomLatest(listActions.INIT_CREATE_SALE_ALLOCATION, initSaleAssignmentEffect)
}

function* getSaleAllocationSaga() {
  yield takeCustomLatest(listActions.FETCH_SALE_ALLOCATION, getSaleAllocationEffects)
}

function* updateSaleAllocationSaga() {
  yield takeCustomLatest(listActions.UPDATE_SALE_ALLOCATION, updateSaleAllocationEffects)
}

export const ListWatchers = [
  refetchListSaga(),
  fetchActiveSalesAllocationSaga(),
  createNewSaleAssignmentSaga(),
  createNewSaleAllocationSaga(),
  initSaleAssignmentSaga(),
  getSaleAllocationSaga(),
  updateSaleAllocationSaga()
]
